// extracted by mini-css-extract-plugin
export var option = "_5f-0";
export var optionCard = "_5f-f";
export var optionContent = "_5f-g";
export var optionIcon = "_5f-i";
export var optionIconBox = "_5f-h";
export var optionLabel = "_5f-j";
export var optionPill = "_5f-m";
export var optionPillBadge = "_5f-p";
export var optionPillIcon = "_5f-n";
export var optionPillLabel = "_5f-o";
export var optionRadio = "_5f-k";
export var optionRadioInner = "_5f-l";
export var optionReveal = "_5f-2";
export var optionRevealDelay0 = "_5f-3";
export var optionRevealDelay1 = "_5f-4";
export var optionRevealDelay10 = "_5f-d";
export var optionRevealDelay11 = "_5f-e";
export var optionRevealDelay2 = "_5f-5";
export var optionRevealDelay3 = "_5f-6";
export var optionRevealDelay4 = "_5f-7";
export var optionRevealDelay5 = "_5f-8";
export var optionRevealDelay6 = "_5f-9";
export var optionRevealDelay7 = "_5f-a";
export var optionRevealDelay8 = "_5f-b";
export var optionRevealDelay9 = "_5f-c";
export var optionSelected = "_5f-1";